(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ante-content-block-timeline"] && !Shopify.designMode) return;
  try {
    if (!(window.CSS && CSS.supports && (CSS.supports("animation-timeline: scroll()") || CSS.supports("animation-timeline: --t")))) {
    const clamp = (value) => Math.min(1, Math.max(0, value))

    const localProgress = (p, a, b) => b === a ? (p * 100 >= a ? 1 : 0) : clamp((p * 100 - a) / (b - a))

    const parseRange = (value, fallback) => (value || fallback).split(" ").map(parseFloat)

    const update = () => {
      const viewport = window.innerHeight
      const lines = document.querySelectorAll(".content-block-timeline .timeline-line.timeline-line-progression")
      for (const line of lines) {
        const container = line.closest(".content-block-timeline")
        if (!container) continue

        const rect = line.getBoundingClientRect()
        const p = clamp((viewport - rect.top) / (viewport + rect.height))

        const mobile = container.clientWidth <= 500
        const lineRange = parseRange(mobile ? line.getAttribute("data-timeline-range-mobile") : line.getAttribute("data-timeline-range"), "10 60")
        line.style.clipPath = "inset(0 0 " + ((1 - localProgress(p, lineRange[0], lineRange[1])) * 100) + "% 0)"

        for (const badge of container.querySelectorAll(".timeline-badge.timeline-badge-progression")) {
          const range = parseRange(badge.getAttribute("data-timeline-range"), "10 18")
          badge.style.opacity = localProgress(p, range[0], range[1])
        }
      }
    }

    const onReady = () => {
      update()
      window.addEventListener("scroll", update, { passive: true })
      window.addEventListener("resize", update)
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", onReady)
    } else {
      onReady()
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-i279-gift"] && !Shopify.designMode) return;
  try {
    function i279GiftAmount() {
    let raw = new URL(location.href).searchParams.get("gc")
    try {
      if (raw) sessionStorage.setItem("i279-gc", raw)
      else raw = sessionStorage.getItem("i279-gc")
    } catch {}
    if (!raw || !/^\d{1,4}(\.\d{1,2})?$/.test(raw)) return null
    return Number(raw)
  }

  const i279Gift = i279GiftAmount()

  function i279GiftFill(root) {
    if (i279Gift === null) return
    const rate = Number(window.Shopify?.currency?.rate) || 1
    const value = i279Gift * rate
    const money = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: "currency", currency: window.Shopify?.currency?.active || "USD", minimumFractionDigits: value % 1 ? 2 : 0, maximumFractionDigits: value % 1 ? 2 : 0 }).format(value)
    root.querySelectorAll("[data-i279-gc]:not([data-i279-gc-done])").forEach(el => {
      el.setAttribute("data-i279-gc-done", "")
      el.innerHTML = `<strong>${money}</strong> gift card`
    })
    root.querySelectorAll("[data-i279-gc-art]:not([data-i279-gc-done])").forEach(art => {
      art.setAttribute("data-i279-gc-done", "")
      const src = JSON.parse(art.dataset.i279GcArt)[String(i279Gift)]
      const img = art.querySelector("img")
      if (!src || !img) return
      img.removeAttribute("srcset")
      img.removeAttribute("sizes")
      img.src = src
    })
  }

  i279GiftFill(document)
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => node.nodeType === 1 && i279GiftFill(node)))).observe(document.documentElement, { childList: true, subtree: true })

  function i279GiftCode() {
    let code = new URL(location.href).searchParams.get("code")?.trim()
    try {
      if (code) {
        sessionStorage.setItem("i279-code", code)
        sessionStorage.removeItem("i279-code-removed")
      } else {
        code = sessionStorage.getItem("i279-code")
        if (code && sessionStorage.getItem("i279-code-removed") === code) return null
      }
    } catch {}
    return code || null
  }

  let i279Code = i279GiftCode()
  let i279CodeBusy = false
  let i279CodeTried = ""

  async function i279ApplyCode(cart) {
    if (!i279Code || i279CodeBusy) return
    cart ||= await fetch("/cart.js").then(r => r.json())
    if ((cart.discount_codes || []).some(d => d.code.toLowerCase() === i279Code.toLowerCase())) return
    const state = `${cart.item_count}:${cart.total_price}`
    if (i279CodeTried === state) return
    i279CodeTried = state
    i279CodeBusy = true
    try {
      const codes = (cart.discount_codes || []).map(d => d.code).concat(i279Code)
      const updated = await fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ discount: codes.join(",") }) }).then(r => r.json())
      if (window.SlideCart && updated.item_count) await window.SlideCart.refresh(updated, { silent: true })
    } finally {
      i279CodeBusy = false
    }
  }

  if (i279Code) {
    i279ApplyCode()
    document.addEventListener("slide-cart:update", e => i279ApplyCode(e.detail?.cart))
    document.addEventListener("click", e => {
      const remove = e.target.closest(".slide-cart-discount-remove")
      if (!remove || !i279Code || remove.dataset.code?.toLowerCase() !== i279Code.toLowerCase()) return
      try { sessionStorage.setItem("i279-code-removed", i279Code) } catch {}
      i279Code = null
    }, true)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-i279-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener("click", async e => {
    const button = e.target.closest("[data-i279-add]")
    if (!button || button.hasAttribute("loading") || button.hasAttribute("disabled")) return
    const from = window.antePageId || new URL(location.href).pathname.split("/").at(-1)
    const group = button.dataset.i279Add ? `,g:${button.dataset.i279Add}` : ""
    button.setAttribute("loading", "")
    try {
      await window.addToCart({
        items: [{ id: Number(button.dataset.variantId), quantity: 1, properties: { _data: `f:${from},t:m${group}` } }],
        location: "/cart"
      })
    } finally {
      button.removeAttribute("loading")
    }
  })

  let i279PickCount = 0

  document.addEventListener("click", e => {
    const opener = e.target.closest("[data-i279-pick]")
    if (!opener || opener.hasAttribute("disabled")) return
    const card = opener.closest(".i279-card")
    const variants = JSON.parse(card.querySelector("[data-i279-variants]").textContent)
    const section = card.closest(".ante-section")
    const theme = section ? Array.from(section.classList).filter(name => name.startsWith("color-theme-") || (name.startsWith("ante-") && name !== "ante-section")) : []
    const pick = ++i279PickCount
    window.openModal("", card.querySelector("template[data-i279-pick-template]").innerHTML, "i279-quickshop", modal => {
      if (theme.length) modal.classList.add(...theme)
      const shop = modal.querySelector(".i279-qs-single")
      const button = shop.querySelector("[data-i279-pick-add]")
      const choices = Array.from(shop.querySelectorAll("[data-i279-pick-option]"))
      let variant = variants.find(v => String(v.id) === shop.dataset.variant)
      choices.forEach(choice => choice.querySelectorAll("input").forEach(input => input.name = `i279-pick-${pick}-${choice.dataset.i279PickOption}`))
      shop.querySelector("[data-i279-qs-close]").addEventListener("click", () => modal.close())

      function show() {
        choices.forEach(choice => {
          const value = variant.o[choice.dataset.i279PickOption]
          choice.querySelectorAll("input").forEach(input => input.checked = input.value === value)
          choice.querySelector("[data-i279-pick-value]").textContent = value
        })
        shop.querySelector("[data-i279-pick-name]").textContent = variant.n
        shop.querySelector("[data-i279-pick-price]").innerHTML = variant.p
        shop.querySelectorAll("[data-i279-pick-image]").forEach(img => {
          if (!variant.i) return
          img.src = variant.i
          img.alt = variant.n
        })
        window.setPrice(variant.pr, variant.cp > variant.pr ? variant.cp : null)
        button.toggleAttribute("disabled", !variant.a)
        button.setAttribute("text", variant.a ? shop.dataset.text : "Sold out")
      }

      shop.addEventListener("change", e => {
        const choice = e.target.closest("[data-i279-pick-option]")
        if (!choice) return
        const index = Number(choice.dataset.i279PickOption)
        const wanted = variant.o.slice()
        wanted[index] = e.target.value
        variant = variants.find(v => v.o.every((value, i) => value === wanted[i])) || variants.find(v => v.a && v.o[index] === wanted[index]) || variants.find(v => v.o[index] === wanted[index])
        show()
      })

      button.addEventListener("click", async () => {
        if (button.hasAttribute("loading") || button.hasAttribute("disabled")) return
        const from = window.antePageId || new URL(location.href).pathname.split("/").at(-1)
        const group = opener.dataset.i279Pick ? `,g:${opener.dataset.i279Pick}` : ""
        button.setAttribute("loading", "")
        try {
          await window.addToCart({
            items: [{ id: variant.id, quantity: 1, properties: { _data: `f:${from},t:m${group}` } }],
            location: "/cart"
          })
          modal.close()
        } finally {
          button.removeAttribute("loading")
        }
      })

      show()
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-i279-product-info"] && !Shopify.designMode) return;
  try {
    const i279InfoCache = new Map()

  function i279InfoFetch(url) {
    if (!i279InfoCache.has(url)) {
      const request = fetch(`${url}${url.includes("?") ? "&" : "?"}view=i279-info`).then(r => {
        if (!r.ok) throw new Error(`i279 product info ${r.status} for ${url}`)
        return r.text()
      })
      request.catch(() => i279InfoCache.delete(url))
      i279InfoCache.set(url, request)
    }
    return i279InfoCache.get(url)
  }

  function i279Theme(el) {
    const source = el.closest(".modal-element") || el.closest(".ante-section")
    return source ? Array.from(source.classList).filter(name => name.startsWith("color-theme-") || (name.startsWith("ante-") && name !== "ante-section")) : []
  }

  function i279TipTheme(e) {
    const thumb = e.target.closest?.(".i279-thumb[data-easy-tooltip-src]")
    if (thumb && !thumb.hasAttribute("data-i279-tip-themed")) {
      thumb.setAttribute("data-i279-tip-themed", "")
      thumb.dataset.easyTooltipClass = ["i279-tip-tooltip"].concat(i279Theme(thumb)).join(" ")
    }
  }

  document.addEventListener("pointerover", e => {
    i279TipTheme(e)
    const opener = e.target.closest("[data-i279-info]")
    if (opener?.dataset.i279Info) i279InfoFetch(opener.dataset.i279Info).catch(() => {})
  })

  document.addEventListener("focusin", i279TipTheme)

  function i279TipPreload() {
    const urls = new Set(Array.from(document.querySelectorAll(".i279-thumb + div[hidden] .i279-tip-image")).map(img => img.getAttribute("src")))
    urls.forEach(url => {
      const img = new Image()
      img.src = url
    })
  }

  const i279Idle = window.requestIdleCallback || (fn => setTimeout(fn, 200))
  if (document.readyState === "complete") i279Idle(i279TipPreload)
  else addEventListener("load", () => i279Idle(i279TipPreload), { once: true })

  async function i279InfoOpen(opener) {
    const url = opener.dataset.i279Info
    if (!url || opener.hasAttribute("loading")) return
    opener.setAttribute("loading", "")
    let html
    try {
      html = await i279InfoFetch(url)
    } finally {
      opener.removeAttribute("loading")
    }
    const theme = i279Theme(opener)
    window.openModal("", html, "i279-product-info", modal => {
      if (theme.length) modal.classList.add(...theme)
      modal.querySelector("[data-i279-info-close]").addEventListener("click", () => modal.close())
    })
  }

  document.addEventListener("click", e => {
    const opener = e.target.closest("[data-i279-info]")
    if (!opener) return
    e.preventDefault()
    e.stopPropagation()
    i279InfoOpen(opener)
  }, true)

  document.addEventListener("keydown", e => {
    if (e.key !== "Enter" && e.key !== " ") return
    const opener = e.target.closest("[data-i279-info]")
    if (!opener || opener.tagName === "BUTTON") return
    e.preventDefault()
    i279InfoOpen(opener)
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-i279-quickshop"] && !Shopify.designMode) return;
  try {
    function i279TierPicker(panels, current, show) {
    const shop = panels[current]
    const fieldset = document.createElement("fieldset")
    fieldset.className = "i279-qs-choice i279-qs-tier"
    const legend = document.createElement("legend")
    legend.className = "body-caption-x-small"
    legend.append(`${shop.dataset.tierLabel}: `)
    const value = document.createElement("span")
    value.className = "i279-qs-value"
    value.textContent = `${shop.dataset.tierName} · ${shop.dataset.tierPrice}`
    legend.append(value)
    const pills = document.createElement("div")
    pills.className = "i279-qs-pills"
    panels.forEach((panel, i) => {
      const label = document.createElement("label")
      label.className = panel.dataset.tierImage ? "i279-qs-swatch" : "i279-qs-pill body-small"
      label.title = `${panel.dataset.tierName} · ${panel.dataset.tierPrice}`
      const input = document.createElement("input")
      input.type = "radio"
      input.name = `i279-qs-tier-${current}`
      input.checked = i === current
      input.addEventListener("change", () => show(i))
      const span = document.createElement("span")
      if (panel.dataset.tierImage) {
        const img = document.createElement("img")
        img.src = panel.dataset.tierImage
        img.alt = panel.dataset.tierName
        span.append(img)
      } else {
        span.textContent = panel.dataset.tierName
      }
      label.append(input, span)
      pills.append(label)
    })
    fieldset.append(legend, pills)
    shop.querySelector(".i279-qs-choose").prepend(fieldset)
  }

  function i279SetupPanel(modal, shop, panelIndex) {
    const discount = Number(shop.dataset.discount)
    const fixed = JSON.parse(shop.dataset.fixed)
    const button = shop.querySelector(".i279-qs-cta buy-button")
    if (shop.dataset.problems) console.error(`i279 bundle "${shop.dataset.name}": ${shop.dataset.problems.split("||").filter(Boolean).join("; ")}`)

    shop.querySelector("[data-i279-qs-close]").addEventListener("click", () => modal.close())

    const drop = shop.querySelector(".i279-qs-customize .drop-menu")
    drop?.querySelector(":scope > .drop-content-container").addEventListener("click", () => setTimeout(() => drop.querySelector(":scope > input").checked = true))

    const choices = Array.from(shop.querySelectorAll(".i279-qs-choice:not(.i279-qs-tier)"))
    choices.forEach(choice => {
      const name = `i279-qs-${panelIndex}-${choice.dataset.name}`
      const inputs = Array.from(choice.querySelectorAll(".i279-qs-pills input"))
      inputs.forEach(input => input.name = name)
      const formats = choice.dataset.formats ? choice.dataset.formats.split("|") : []
      const enabled = inputs.filter(input => !input.disabled && (!formats.length || input.dataset.format === formats[0]))
      const pick = enabled[Number(choice.dataset.default)] || enabled[0] || inputs.find(input => !input.disabled)
      if (pick) pick.checked = true
      if (formats.length < 2) return

      function showFormat(format) {
        inputs.forEach(input => input.closest("label").hidden = input.dataset.format !== format)
      }

      const toggle = document.createElement("div")
      toggle.className = "i279-qs-formats"
      formats.forEach(format => {
        const label = document.createElement("label")
        label.className = "i279-qs-pill body-small"
        const input = document.createElement("input")
        input.type = "radio"
        input.name = `${name}-format`
        input.checked = format === (pick?.dataset.format || formats[0])
        input.addEventListener("change", () => {
          const scent = choice.querySelector(".i279-qs-pills input:checked")?.dataset.scent
          const options = inputs.filter(option => option.dataset.format === format && !option.disabled)
          const next = options.find(option => option.dataset.scent === scent) || options[0]
          if (next) next.checked = true
          showFormat(format)
        })
        const span = document.createElement("span")
        span.textContent = format
        label.append(input, span)
        toggle.append(label)
      })
      choice.querySelector(".i279-qs-pills").before(toggle)
      showFormat(pick?.dataset.format || formats[0])
    })

    function selectedLines() {
      let lines = fixed
      let complete = true
      choices.forEach(choice => {
        const checked = choice.querySelector(".i279-qs-pills input:checked")
        choice.querySelector("[data-i279-qs-value]").textContent = checked ? checked.dataset.label : ""
        const row = shop.querySelector(`[data-i279-qs-pick="${choice.dataset.name}"]`)
        if (row) {
          row.querySelector("[data-i279-qs-pick-label]").textContent = checked ? checked.dataset.label : ""
          if (checked?.dataset.info) row.querySelector("[data-i279-info]").dataset.i279Info = checked.dataset.info
          const swatch = checked?.closest("label").querySelector("img")
          const thumb = row.querySelector(".i279-qs-thumb img")
          if (swatch && thumb) {
            thumb.srcset = swatch.srcset
            thumb.src = swatch.src
          }
        }
        if (checked) {
          lines = lines.concat(JSON.parse(checked.dataset.parts))
        } else {
          complete = false
        }
      })
      return { lines, complete }
    }

    function update() {
      if (shop.hidden) return
      const { lines, complete } = selectedLines()
      const total = lines.reduce((sum, line) => sum + line.p * line.q, 0)
      const price = Math.round(total * (100 - discount) / 100)
      window.setPrice(price, total > price ? total : null)
      button.toggleAttribute("disabled", !complete || !lines.length)
    }

    shop.addEventListener("change", e => {
      if (!e.target.closest(".i279-qs-tier")) update()
    })

    button.addEventListener("click", async () => {
      if (button.hasAttribute("loading") || button.hasAttribute("disabled")) return
      const from = window.antePageId || new URL(location.href).pathname.split("/").at(-1)
      const { lines } = selectedLines()
      const split = lines.some(line => line.g > 1)
      const quantities = new Map()
      lines.forEach(line => {
        const key = `${line.id}|${split ? line.g : 0}`
        quantities.set(key, (quantities.get(key) || 0) + line.q)
      })
      const items = Array.from(quantities, ([key, quantity]) => {
        const [id, group] = key.split("|")
        return { id: Number(id), quantity, properties: { _data: `f:${from},t:b,b:${shop.dataset.index}${split ? `,p:${group}` : ""}` } }
      })
      button.setAttribute("loading", "")
      try {
        await window.addBundleToCart(items, { name: shop.dataset.name, image: shop.dataset.image, location: "/cart" })
        modal.close()
      } finally {
        button.removeAttribute("loading")
      }
    })

    return update
  }

  document.addEventListener("click", e => {
    const opener = e.target.closest("[data-i279-quickshop-open]")
    if (!opener || opener.hasAttribute("disabled")) return
    const template = opener.parentElement.querySelector("template[data-i279-quickshop]")
    window.openModal("", template.innerHTML, "i279-quickshop", modal => {
      const panels = Array.from(modal.querySelectorAll(".i279-qs"))
      modal.classList.add(...panels[0].dataset.theme.split(" ").filter(Boolean))
      panels.forEach((panel, i) => panel.hidden = i > 0)
      const updates = panels.map((panel, i) => i279SetupPanel(modal, panel, i))
      function show(index) {
        panels.forEach((panel, i) => panel.hidden = i !== index)
        panels[index].querySelectorAll(".i279-qs-tier input").forEach((input, i) => input.checked = i === index)
        const customize = panels[index].querySelector(".i279-qs-customize .drop-menu > input")
        if (customize) customize.checked = true
        panels[index].querySelector(".i279-qs-tier")?.scrollIntoView({ block: "center" })
        updates[index]()
      }
      if (panels.length > 1) panels.forEach((panel, i) => panel.dataset.tierLabel && i279TierPicker(panels, i, show))
      updates[0]()
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-image"] && !Shopify.designMode) return;
  try {
    function destroyVideo(wrapper) {
    const video = wrapper?.querySelector("video")
    if (!video) return

    video.pause()
    video.removeAttribute("src")
    video.load()

    for (const source of video.querySelectorAll("source")) {
      source.remove()
    }

    video.srcObject = null
    wrapper.remove()
  }

  function removeInlineVideo(image) {
    destroyVideo(image._inlineVideo)
    image._inlineVideo = null
    image._inlineActive = false
    image.classList.remove("video-inlined")
  }

  function removeHoverVideo(image) {
    destroyVideo(image._video)
    image._video = null
    image._video_removed = true
    image.classList.remove("video-previewing")
  }

  document.addEventListener("mouseenter", e => {
    const image = e.target.closest?.(".ante-image")
    if (!image || image._inlineActive || image._video) return

    const modal = image.dataset.modal ?? image.dataset.video
    if (!modal) return

    image._video_removed = false
    image._video = document.createElement("div")
    image._video.classList.add("ante-image-video-preview")
    image._video.innerHTML = modal

    const video = image._video.querySelector("video")
    video.removeAttribute("controls")
    video.muted = true

    function onReady() {
      if (!image._video_removed && !image._inlineActive) {
        image.append(image._video)
        image.classList.add("video-previewing")
        video.play()
      }
    }

    if (video.readyState >= 2) onReady()
    else video.addEventListener("loadeddata", onReady, { once: true })
  }, true)

  document.addEventListener("mouseleave", e => {
    const image = e.target.closest?.(".ante-image")
    if (!image || image._inlineActive) return
    removeHoverVideo(image)
  }, true)

  document.addEventListener("click", e => {
    const image = e.target.closest?.(".ante-image")

    for (const el of document.querySelectorAll(".ante-image.video-inlined")) {
      if (el !== image) removeInlineVideo(el)
    }

    if (image && image.dataset.video) {
      if (image._inlineActive) return

      let resumeTime = 0
      let resume = false

      if (image._video) {
        const previewVideo = image._video.querySelector("video")
        if (previewVideo && Number.isFinite(previewVideo.currentTime) && previewVideo.currentTime > 0) {
          resumeTime = previewVideo.currentTime
          resume = true
        }
      }

      removeHoverVideo(image)

      image._inlineActive = true
      image._inlineVideo = document.createElement("div")
      image._inlineVideo.classList.add("ante-image-video-inline")
      image._inlineVideo.innerHTML = image.dataset.video

      const realVideo = image._inlineVideo.querySelector("video")
      realVideo.setAttribute("controls", "")

      if (resume) {
        function applyResume() {
          const duration = Number.isFinite(realVideo.duration) ? realVideo.duration : 0
          realVideo.currentTime = duration > 0 ? Math.min(resumeTime, Math.max(0, duration - 0.05)) : resumeTime
        }
        if (realVideo.readyState >= 1) applyResume()
        else realVideo.addEventListener("loadedmetadata", applyResume, { once: true })
      }

      image.append(image._inlineVideo)
      image.classList.add("video-inlined")
      realVideo.play()
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-import-main"] && !Shopify.designMode) return;
  try {
    // Smooth scrolling

  window.getStickyTop = () => {
    const el = document.createElement("div")
    el.style.position = "fixed"
    el.style.top = "var(--sticky-top, 64px)"
    el.style.left = "0"
    el.style.width = "0"
    el.style.height = "0"
    el.style.pointerEvents = "none"
    el.style.visibility = "hidden"
    document.body.appendChild(el)
    const value = el.getBoundingClientRect().top
    el.remove()
    return value
  }

  function getElementTop(el) {
    let offset = 0
    if (el.classList.contains("ante-section")) {
      const child = el.firstElementChild
      if (child) {
        offset = parseFloat(getComputedStyle(child).paddingTop) || 0
      }
    } else if (el.classList.contains("ante-container")) {
      offset = parseFloat(getComputedStyle(el).paddingTop) || 0
    } else {
      if (Math.round(el.clientWidth) === document.documentElement.clientWidth) {
        offset = parseFloat(getComputedStyle(el).paddingTop) || 0
      }
    }

    let extra = 0
    let p = el.parentElement
    while (p) {
      if (getComputedStyle(p).position === "sticky" && p.parentElement) {
        const gap = p.parentElement.getBoundingClientRect().bottom - p.getBoundingClientRect().bottom
        if (gap > 0) extra += gap
      }
      p = p.parentElement
    }

    return el.getBoundingClientRect().top + window.scrollY - getStickyTop() + offset + extra
  }

  window.smoothScroll = (element, args = {}) => {
    let el = element

    while (el && getComputedStyle(el).display === "none") {
      el = el.nextElementSibling
    }

    if (!el) el = element

    if (args.lazy) {
      const rect = el.getBoundingClientRect()
      if (rect.top >= getStickyTop() && rect.bottom <= window.innerHeight) return
    }

    let attempts = 0
    let lastTop = null

    // nearest travels the least distance that puts the element on screen, rather than
    // pulling it to the top, leaving a small section spacer of room so it doesn't land
    // flush against the bottom edge. Anything already in view stays where it is.
    function nearestPadding() {
      // --section-spacer is fluid, so it has to be measured rather than parsed.
      const probe = document.createElement("div")
      probe.style.cssText = "position:absolute;visibility:hidden;height:var(--section-spacer-small)"
      document.body.append(probe)
      const px = probe.getBoundingClientRect().height
      probe.remove()
      return px
    }

    const pad = args.nearest ? nearestPadding() : 0

    function targetTop() {
      const top = getElementTop(el)
      if (!args.nearest) return top

      const rect = el.getBoundingClientRect()
      const ceiling = getStickyTop()

      if (rect.top >= ceiling && rect.bottom + pad <= window.innerHeight) return window.scrollY
      if (rect.bottom + pad > window.innerHeight) {
        // Coming up from below, but never past the point where it sits at the top.
        return Math.min(window.scrollY + rect.bottom + pad - window.innerHeight, top)
      }
      return top
    }

    function scroll() {
      const top = targetTop()
      if (lastTop !== null && Math.abs(top - lastTop) < 2) return
      lastTop = top

      window.scrollTo({ top, behavior: "smooth" })
      attempts++
      if (attempts < 4) setTimeout(scroll, 500)
    }

    scroll()
  }

  function handleHash(id) {
    const escaped = CSS.escape(id)
    const modalMatches = Array.from(document.querySelectorAll(`#modal-content-${escaped}`))
    if (modalMatches.length) {
      const modalContent = modalMatches[modalMatches.length - 1]
      showAnchorModal(JSON.parse(modalContent.textContent))
      return true
    }

    const target = document.querySelector(id.startsWith(".") || id.startsWith("[") ? id : `#${escaped}`)
    if (!target) return false

    smoothScroll(target)
    history.replaceState(null, "", window.location.pathname + window.location.search)
    return target
  }

  if (window.location.hash) {
    const hash = window.location.hash.slice(1)
    history.replaceState(null, "", window.location.pathname + window.location.search)
    window.scrollTo(0, 0)
    try { handleHash(hash) } catch (e) {}
  }

  document.body.addEventListener("click", e => {
    const link = e.target.closest("a[href*='#']")
    if (!link) return

    const href = link.getAttribute("href")
    const hashIndex = href.indexOf("#")
    if (hashIndex === -1) return
    const id = href.slice(hashIndex + 1)
    if (!id) return

    const before = href.slice(0, hashIndex)
    if (before && before !== window.location.pathname && before !== window.location.origin + window.location.pathname) return

    const target = handleHash(id)
    if (!target) return

    e.preventDefault()

    if (target !== true && "click" in link.dataset) {
      if (target.previousElementSibling?.type == "checkbox" && target.previousElementSibling?.checked) {
        return
      }
      target.click()
    }
  })

  // Show cart

  window.showCart = () => {
    if (window.SlideCart) SlideCart.load()
    else if (window.SLIDECART_OPEN) SLIDECART_OPEN()
    else if (window.Rebuy?.SmartCart) Rebuy.SmartCart.show()
    else window.location = "/cart"
  }

  // Add to cart

  window.addToCart = async ({ items, discount, clearCart, clearDiscount, location: redirect, postAddCartSyncDelay = 0 }) => {
    items = items.map(item => ({
      ...item,
      properties: {
        // derived, but listed first so a caller that sets it explicitly still wins
        _subscription: item.selling_plan ? "true" : "false",
        ...(item.properties || {}),
        _from: [window._template?.name, window._template?.suffix].filter(Boolean).join("."),
        ...(window.anteAd?.() ? { _ad: window.anteAd() } : {})
      }
    }))

    const normalizedRedirect = String(redirect || "").trim()
    const cartRedirect = normalizedRedirect === "/cart"

    let opened = false
    let openTimeout
    if (cartRedirect && window.SlideCart) {
      openTimeout = setTimeout(() => {
        opened = true
        SlideCart.show()
        SlideCart.showMessage(SlideCart.messages.adding)
      }, 250)
    }

    if (clearCart) await fetch("/cart/clear.js")

    if (discount || clearDiscount) await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: "" })
    })

    const bundleSections = cartRedirect && window.SlideCart && !discount

    const addRequest = fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items, sections: bundleSections ? window.SlideCart.sectionId : undefined })
    })

    // SlideCart applies the discount sequentially so it can show a message; without it there's no message, so fire the discount in parallel for actual speed.
    const discountRequest = discount && cartRedirect && !window.SlideCart ? fetch(`/discount/${encodeURIComponent(discount)}`) : null

    const [r] = await Promise.all([addRequest, discountRequest].filter(Boolean))

    if (openTimeout) clearTimeout(openTimeout)

    if (!r.ok) {
      if (opened) SlideCart.refresh()
      throw new Error(await r.text())
    }

    let addedSections = null
    if (bundleSections) {
      try { addedSections = (await r.json()).sections?.[window.SlideCart.sectionId] || null } catch (_) {}
    }

    if (discount && cartRedirect && window.SlideCart) {
      if (!opened) {
        opened = true
        SlideCart.show()
      }
      SlideCart.showMessage(SlideCart.messages.applyingDiscount)
      await fetch(`/discount/${encodeURIComponent(discount)}`)
    }

    // Shipping discount rules count the cart's own lines, so this can only run once the
    // add has landed. A redirect that leaves the page must wait for it, since the cart is
    // read at checkout; the slide cart and the no-redirect case can let it settle behind
    // the scenes. Optional chaining because the controller section is per-store.
    const shippingRules = window.anteShippingDiscounts?.sync()
    if (normalizedRedirect && !cartRedirect) await shippingRules

    if (cartRedirect) {
      if (window.SlideCart) {
        if (!opened) SlideCart.show()
        await SlideCart.refresh(null, { sections: addedSections })

        if (postAddCartSyncDelay > 0) {
          window.setTimeout(async () => {
            try {
              const latestCart = await fetch("/cart.js").then(response => response.json())
              document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "variant:add",
                  cart: latestCart
                }
              }))
              await SlideCart.refresh(latestCart, { silent: true })
            } catch (error) {
              console.warn("Post add cart sync failed", error)
            }
          }, postAddCartSyncDelay)
        }
      } else if (window.SLIDECART_OPEN) {
        if (window.SLIDECART_UPDATE) SLIDECART_UPDATE(SLIDECART_OPEN)
        else SLIDECART_OPEN()
      } else {
        window.location = "/cart"
      }
      return
    }

    if (!normalizedRedirect) return

    window.location = discount
      ? `/discount/${encodeURIComponent(discount)}?redirect=${encodeURIComponent(normalizedRedirect)}`
      : normalizedRedirect
  }

  // Add bundle to cart

  const BUNDLE_PRIME = 2147483647
  const BUNDLE_BASE = 31

  const bundleGcd = (a, b) => (b === 0 ? a : bundleGcd(b, a % b))

  const bundleId = (items) => {
    const g = items.map(i => i.quantity).reduce(bundleGcd)
    let sum = 0
    for (const i of items) {
      const q = Math.min(i.quantity / g, 9999)
      const s = `${i.id}${String(q).padStart(4, "0")}`
      let h = 0
      for (const d of s) {
        h = (h * BUNDLE_BASE + Number(d)) % BUNDLE_PRIME
      }
      sum = (sum + h) % BUNDLE_PRIME
    }
    return sum
  }

  window.addBundleToCart = async (lines, { name = "Bundle", image, discount, clearCart, clearDiscount, location, postAddCartSyncDelay = 0 } = {}) => {
    const totals = {}
    for (const l of lines) {
      totals[l.id] = (totals[l.id] || 0) + l.quantity
    }
    const magic = bundleId(Object.entries(totals).map(([id, quantity]) => ({ id, quantity })))
    const metaVariant = Object.keys(totals).reduce((a, b) => (Number(a) < Number(b) ? a : b))
    let metaAssigned = false
    const items = lines.map(l => {
      const isMeta = !metaAssigned && String(l.id) === String(metaVariant)
      if (isMeta) metaAssigned = true
      return {
        ...l,
        id: parseInt(l.id, 10),
        properties: {
          ...(l.properties || {}),
          _pxl_bundle: "true",
          _pxl_bundle_id: String(magic),
          ...(isMeta ? { _pxl_bundle_name: name, ...(image ? { _pxl_bundle_image: image } : {}) } : {})
        }
      }
    })
    return addToCart({ items, discount, clearCart, clearDiscount, location, postAddCartSyncDelay })
  }

  // Newsletter

  if (location.search.includes("customer_posted=true") && location.hash === "#newsletter") {
    openModal("Signed up!", "Thanks for subscribing to our newsletter!")
    const url = new URL(location)
    url.searchParams.delete("customer_posted")
    history.replaceState(null, "", url.pathname + url.search)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-import-modals"] && !Shopify.designMode) return;
  try {
    const modals = document.createElement("div")
  modals.id = "modals"
  if (window.anteModalColourTheme) {
    modals.classList.add(`color-theme-${window.anteModalColourTheme}`)
  }
  document.body.append(modals)

  function makeModal(title, content, id, args = {}) {
    const container = document.createElement("div")
    if (id) {
      container.id = id
    }
    container.classList.add("modal-container")
    if (args.type) {
      container.classList.add(`modal-type-${args.type}`)
    }
    container.setAttribute("tabindex", "-1")
    container.innerHTML = `
      <div class="modal-element">
        <div class="modal-title-row">
          <div class="modal-title">${title ?? "Modal"}</div>
          <button class="modal-close" aria-label="Close">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="modal-contents ante-section"></div>
      </div>
    `
    const contents = container.querySelector(".modal-contents")
    if (typeof content === "string") {
      contents.innerHTML = content
    } else {
      contents.append(...content.map(node => node.cloneNode(true)))
    }
    return container
  }

  function handleModal(modal, close, func) {
    modal.querySelector(".modal-title-row .modal-close").addEventListener("click", close)
    let down
    modal.addEventListener("mousedown", e => down = e.target)
    modal.addEventListener("mouseup", e => {
      if (down === e.target && e.target.classList.contains("modal-container")) {
        close()
      }
    })
    modal.addEventListener("keydown", e => {
      if (e.key === "Escape") {
        close()
      } else if (e.key === "Tab") {
        const focusable = modal.querySelectorAll(
          'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        )
        if (!focusable.length) return
        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault()
          last.focus()
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault()
          first.focus()
        }
      }
    })
    if (modal.classList.contains("modal-type-slideout")) {
      const el = modal.querySelector(".modal-element")
      const header = modal.querySelector(".modal-title-row")
      const sheet = window.matchMedia("(max-width: 768px)")
      let startY = 0, delta = 0, lastY = 0, lastT = 0, velocity = 0, height = 0, dragging = false
      header.addEventListener("pointerdown", e => {
        if (!sheet.matches || e.button !== 0 || e.target.closest(".modal-close")) return
        dragging = true
        startY = lastY = e.clientY
        lastT = e.timeStamp
        delta = velocity = 0
        height = el.offsetHeight
        el.style.transition = "none"
        header.setPointerCapture(e.pointerId)
      })
      header.addEventListener("pointermove", e => {
        if (!dragging) return
        delta = Math.min(Math.max(0, e.clientY - startY), height)
        if (e.timeStamp > lastT) velocity = (e.clientY - lastY) / (e.timeStamp - lastT)
        lastY = e.clientY
        lastT = e.timeStamp
        el.style.transform = `translateY(${delta}px)`
      })
      function endDrag() {
        if (!dragging) return
        dragging = false
        el.style.transition = ""
        if (delta > height * 0.25 || velocity > 0.6) close()
        el.style.transform = ""
      }
      header.addEventListener("pointerup", endDrag)
      header.addEventListener("pointercancel", endDrag)
    }

    modals.append(modal)
    if (func) {
      modal.modalElement = modal.querySelector(".modal-element")
      modal.modalElement.close = close
      func(modal.modalElement)
    }
  }

  window.openModal = (title, content, id, func, args = {}) => {
    return new Promise(fulfil => {
      const modal = makeModal(title, content, id, args)
      modal.classList.add("opening")
      function close() {
        if (modal.modalElement?.locked) return
        modal.classList.remove("open")
        modal.classList.add("closing")
        const modalElement = modal.querySelector(".modal-element")
        modalElement.addEventListener("transitionend", function handler(e) {
          if (e.target !== modalElement) return
          modalElement.removeEventListener("transitionend", handler)
          modal.remove()
          const all = modals.querySelectorAll(".modal-container")
          if (all.length) {
            all[all.length - 1].focus()
          }
          fulfil()
        })
      }
      handleModal(modal, close, func)
      void modal.offsetWidth
      modal.classList.remove("opening")
      modal.classList.add("open")
      const focusable = modal.querySelectorAll(
        'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )
      if (focusable.length > 1) {
        focusable[1].focus()
      } else {
        modal.focus()
      }
    })
  }

  document.addEventListener("click", e => {
    const el = e.target.closest("[data-modal], .modal")
    if (!el) return

    if (el.hasAttribute("data-modal")) {
      openModal(
        el.dataset.modalTitle,
        el.dataset.modal,
        el.dataset.modalId,
        null,
        el.dataset.modalType
      )
      return
    }

    const modals = document.querySelectorAll(".modal")
    for (const modal of modals) {
      if (!modal.dataset.trigger) continue
      if (e.target.closest("." + modal.dataset.trigger)) {
        if (!modal._modalData) {
          modal._modalData = {
            title: modal.dataset.title,
            content: [...modal.children],
            id: modal.dataset.modalId ?? modal.dataset.trigger + "-modal",
            type: modal.dataset.modalType
          }
        }

        const d = modal._modalData
        openModal(d.title, d.content, d.id, null, d.type)
        return
      }
    }
  })

  function showAnchorModal(data) {
    history.replaceState(null, "", location.pathname + location.search)
    let style = "<style>"
    if (data.width > 0) {
      style += `.modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.width}), var(--modal-max-width)); }\n`
      style += `@media (max-width: 1440px) { .modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.widthSmallDesktop}), var(--modal-max-width)); } }\n`
      style += `@media (max-width: 1024px) { .modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.widthTablet}), var(--modal-max-width)); } }\n`
      style += `@media (max-width: 600px) { .modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.widthMobile}), var(--modal-max-width)); } }\n`
    }
    let content = ""
    const id = data.contentType === "video" ? "video-modal" : "modal-" + Math.random().toString(16).replace("0.", "")
    if (data.contentType === "with_image") {
      content += `
        <div class="modal-with-image-top">
          <div class="richtext">${data.content.imageContent}</div>
          ${data.content.image ? `<img src="${data.content.image}">` : ""}
        </div>
        ${data.content.secondaryContent ? `<div class="richtext">${data.content.secondaryContent}</div>` : ""}
      `
      style += `
        .richtext .modal-with-image-top {
          display: flex !important;
          flex-direction: row;
          gap: var(--spacing-medium);
          margin-bottom: var(--spacing-small);
          align-items: center;
        }

        .modal-with-image-top:nth-last-child(3) {
          margin-bottom: var(--spacing-small);
        }

        .modal-with-image-top:first-child {
          flex: 1;
          align-self: flex-start;
        }

        .modal-with-image-top img {
          max-width: min(100%, ${data.content.imageWidth}px);
        }

        @media (max-width: 600px) {
          .modal-with-image-top {
            flex-direction: column !important;
          }
        }
      `
    } else if (data.contentType === "iframe") {
      content += `<iframe src="${data.content.iframeURL}"></iframe>`
      style += `
        #${id} .modal-contents {
          padding: 0;
        }
        
        #${id} iframe {
          display: block;
          border: none;
          width: 100%;
          height: var(--modal-max-height);
        }
      `
    } else if (data.contentType === "images") {
      content += data.content.images.map(e => `<img src="${e}">`).join("")
    } else if (data.contentType === "video") {
      content += `<video controls playsinline src="${data.content.video}"${data.content.autoplay ? " autoplay" : ""}></video>`
    } else {
      content += data.content.content
    }
    style += "</style>"
    if (style !== "<style></style>") {
      content += style
    }
    openModal(data.content.title, `<div class="richtext">${content}</div>`, id, null, data)
  }
  window.showAnchorModal = showAnchorModal
  } catch(e) { console.error(e); }
})();

})();
